var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeofenceAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#B1CBD9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99184 21.082L14.8459 9.24311C15.2247 8.58881 15.4141 8.26166 15.6612 8.15178C15.8768 8.05593 16.1229 8.05593 16.3384 8.15178C16.5855 8.26166 16.7749 8.58881 17.1537 9.24311L24.0078 21.082C24.388 21.7386 24.578 22.0669 24.55 22.3364C24.5254 22.5715 24.4023 22.785 24.2112 22.924C23.992 23.0833 23.6127 23.0833 22.8539 23.0833H9.14575C8.38698 23.0833 8.00759 23.0833 7.78846 22.924C7.59733 22.785 7.47419 22.5715 7.44968 22.3364C7.42159 22.0669 7.61167 21.7386 7.99184 21.082Z",
    stroke: "#365A6D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeofenceAlert);
export default __webpack_public_path__ + "static/media/geofenceAlert.da3c962b3643568228fd3e5d8d3a0938.svg";
export { ForwardRef as ReactComponent };